import script from "./leaseItemDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./leaseItemDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./leaseItemDetailPage.vue?vue&type=style&index=0&id=ba92aa76&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba92aa76"]])

export default __exports__